import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import LandingPage from './pages/LandingPage';
import AdminLogin from './components/AdminLogin';
import ImportSchedulePage from './pages/ImportSchedulePage';
import SchedulerDashboard from './pages/SchedulerDashboard';
import AdminLayout from './components/AdminLayout';
import AddRageRoom from './pages/AddRageRoom';
import BookingPage from './pages/BookingPage';
import {
  ConfigProvider,
  WebSocketProvider,
  UserProvider,
  TenantProvider,
} from 'm34n-ui';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ConfigProvider>
        <WebSocketProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/book" element={<BookingPage />} />
              <Route path="/admin" element={
                <UserProvider AuthComponent={AdminLogin}>
                    <TenantProvider>
                        <AdminLayout />
                    </TenantProvider>
                </UserProvider>
              }>
                <Route index element={<SchedulerDashboard />} />
                <Route path="rooms" element={<SchedulerDashboard />} />
                <Route path="rooms/new" element={<AddRageRoom />} />
                <Route path="schedules/import" element={<ImportSchedulePage />} />
                <Route path="*" element={<Navigate to="/admin" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </WebSocketProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;